module.exports = __webpack_public_path__ + "b25208a2d916e85a4abf68298e1feb5f.svg";